import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {isMobile} from 'react-device-detect';
import images from '../images/images';
import Config from '../../../../Config';
import callIcon from '../images/call-icon/call-icon.svg';
import callIcon2x from '../images/call-icon/call-icon@2x.svg';
import callIcon3x from '../images/call-icon/call-icon@3x.svg';
import privateCallBtn from '../images/privatecallbtn/privatecallbtn.svg';
import privateCallBtn2x from '../images/privatecallbtn/privatecallbtn@2x.svg';
import privateCallBtn3x from '../images/privatecallbtn/privatecallbtn@3x.svg';

const callIcons = [callIcon, callIcon2x, callIcon3x];
const privateCallBtns = [privateCallBtn, privateCallBtn2x, privateCallBtn3x];

const backgroundImageFromIcons = (icons) => {
  const dpr = window.devicePixelRatio || 1;
  if (dpr >= 3) {
    return icons[2].bg();
  }
  if (dpr >= 2) {
    return icons[1].bg();
  }
  return icons[0].bg();
};

const PaymentsErrorPage = (props) => {
  return (
    <>
      {!props.isBusinessBlock && props.onlyPSIDAccounts && (
        <h2 className='text-center bold onlyPsIdErrorMsg-bold-text'>אופס… משהו השתבש</h2>
      )}
      <div className={`background-container ${props.onlyPSIDAccounts ? 'bg-white' : ''}`}>
        {props.onlyPSIDAccounts ? null : <p className='bold headline-text-description'>לא מצאנו אמצעי תשלום לעדכון</p>}
        {!props.isBusinessBlock ? (
          <>
            {props.onlyPSIDAccounts && (
              <>
                <Image src={images.failUpdate} alt='error' className='onlyPsIdErrorMsg-img' />
                <p className='headline-text-description'>
                  לא ניתן לבצע עדכון אמצעי תשלום בחשבון. באפשרותכם לפנות לשירות לקוחות בשעות הפעילות
                </p>
              </>
            )}
            {isMobile ? (
              <a
                href={`tel:${Config.technicalSupportPhone}`}
                className='headline-text-description call-btn'
                style={{backgroundImage: backgroundImageFromIcons(callIcons)}}>
                {`חייגו ${window.Config.technicalSupportPhone} לנציג`}
              </a>
            ) : (
              <p
                className={`headline-text-description ${props.onlyPSIDAccounts ? 'font-weight-bold' : ''} ${
                  !props.isBusinessBlock && props.onlyPSIDAccounts ? 'call-btn' : ''
                }`}
                style={
                  !props.isBusinessBlock && props.onlyPSIDAccounts
                    ? {backgroundImage: backgroundImageFromIcons(privateCallBtns)}
                    : undefined
                }>
                חייגו ${window.Config.technicalSupportPhone} לנציג
              </p>
            )}
          </>
        ) : (
          <p className='headline-text-description'>כדי לברר את הנושא, צרו איתנו קשר ב-234*</p>
        )}
      </div>
    </>
  );
};
export default PaymentsErrorPage;
